// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1SVYJ","content":"styles_content__3DaXL","checkbox":"styles_checkbox__34-37","checkboxLabel":"styles_checkboxLabel__P_xkJ"};